<template>
    <div class="content-wrapper container-xxl p-0">
        <div class="content-header row"></div>
        <div class="content-body">
            <div class="d-flex justify-content-center" v-if="loading">
                <b-spinner variant="success" label="Spinning" style="width: 3rem; height: 3rem"></b-spinner>
            </div>
            <div class="row">
                <div class="col-xl-4 col-lg-6 col-md-6" v-for="config in itemuom" :key="config.key">
                    <div class="card">
                        <div class="card-body">
                            <div class="d-flex justify-content-between align-items-end mt-1 pt-25">
                                <div>
                                    <!-- <p>{{ config.id }}</p> -->
                                    <h4 class="fw-bolder">{{ config.moduleName }}</h4>
                                    <h5 class="fw-bolder">{{ config.key }}</h5>
                                    <button class="btn btn-primary" @click="openEditModal(config)">
                                        Edit
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <b-modal id="edit-modal" title="Edit Module Config" hide-footer v-model="isModalVisible">
                <div>
                    <h5>Module Name:<p>{{ selectedConfig.moduleName }}</p>
                    </h5>

                    <!-- Tags in Input-Like Field -->
                    <b-form-group label="Value:" label-for="value-input">
                        <div class="tags-field">
                            <div v-for="(tag, index) in tagValues" :key="index" class="tag">
                                {{ tag }}
                                <button type="button" class="btn-close" @click="removeTag(index)">
                                    ×
                                </button>
                            </div>
                            <input type="text" class="tag-input" v-model="newTag" @keyup.enter="addTag"
                                placeholder="Add and press Enter" />
                        </div>
                    </b-form-group>

                    <div class="d-flex justify-content-end">
                        <b-button variant="secondary" @click="closeModal">Cancel</b-button>
                        <b-button type="submit" variant="success" class="ml-2" @click="saveChanges">
                            Save
                        </b-button>
                    </div>
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Swal from 'sweetalert2';
import { BSpinner, BModal, BForm, BFormGroup, BFormInput, BButton } from "bootstrap-vue";

export default {
    name: "UnitOfMeasure",
    components: {
        BSpinner,
        BModal,
        BForm,
        BFormGroup,
        BFormInput,
        BButton,
    },
    data() {
        return {
            isModalVisible: false,
            selectedConfig: {},
            tagValues: [], // Holds the tags for 'value'
            newTag: "", // Holds the current tag being typed
        };
    },
    computed: {
        ...mapGetters("moduleConfig", ["itemuom", "loading"]),
        ...mapGetters("tenantModule", {
      configs: "configs",
      loading: "loading",
    }),
    },
    methods: {
        ...mapActions("moduleConfig", ["getModuleConfigListAction"]),
        ...mapActions("tenantModule",["updateModuleConfigAction"]),
        openEditModal(config) {
            this.selectedConfig = { ...config }; // Clone the selected config
            this.tagValues = config.value ? config.value.split(",").map(tag => tag.trim()) : []; // Parse tags
            this.newTag = "";
            this.isModalVisible = true;
        },

        closeModal() {
            this.isModalVisible = false;
            this.selectedConfig = {};
            this.tagValues = [];
            this.newTag = "";
        },

        addTag() {
            if (this.newTag.trim() && !this.tagValues.includes(this.newTag.trim())) {
                this.tagValues.push(this.newTag.trim());
                this.newTag = "";
            }
        },

        removeTag(index) {
            this.tagValues.splice(index, 1);
        },

        saveChanges() {
            console.log("Saving changes for:", this.selectedConfig);
            console.log("Updated Tags:", this.tagValues);
            // Update the value with the updated tag list
            this.selectedConfig.value = this.tagValues.join(", ");
            //console.log("final value:", this.selectedConfig.value);

            this.updateModuleConfigAction(this.selectedConfig)
            .then(() => {
                this.successEdit();
                this.getModuleConfigListAction();
            })
            .catch(error => {
          // Error handling
        //   this.errorAdd();
        //   this.clearDeliveryForm();
        //   console.error(error);
        });

            this.closeModal();
        },

        successEdit() {
      this.$swal({
        title: "Module Updated!",
        text: "You have successfully updated the module config!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    },
    async mounted() {
        console.log("API URL:", "/tenants/getmoduleconfig");
        try {
            await this.getModuleConfigListAction();
            console.log("Processed Configs:", this.itemuom);
        } catch (error) {
            console.error("Error fetching configs:", error);
        }
    },
};
</script>

<style lang="scss" scoped>
.tags-field {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.5rem;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    padding: 0.5rem;
    background-color: #fff;
}

.tag {
    display: inline-flex;
    align-items: center;
    background-color: #84b365;
    color: #fff;
    padding: 0.25rem 0.5rem;
    border-radius: 0.25rem;
    font-size: 0.875rem;
}

.tag .btn-close {
    margin-left: 0.5rem;
    color: white;
    font-size: 1rem;
    border: none;
    background: none;
    cursor: pointer;
}

.tag-input {
    border: none;
    outline: none;
    flex-grow: 1;
    font-size: 0.875rem;
    padding: 0.25rem;
}
</style>